import { render, staticRenderFns } from "./DailyLearningTab.vue?vue&type=template&id=4c1d378a&scoped=true"
import script from "./DailyLearningTab.vue?vue&type=script&lang=js"
export * from "./DailyLearningTab.vue?vue&type=script&lang=js"
import style0 from "./DailyLearningTab.vue?vue&type=style&index=0&id=4c1d378a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1d378a",
  null
  
)

export default component.exports